import { actionCreatorFactory } from 'typescript-fsa';
import { UserInfoModel } from 'da-pcc-frontend-shared-domain';

const createAction = actionCreatorFactory('USERS');
const fetchUsers = createAction.async<void, UserInfoModel[], Error>('FETCH');

export { fetchUsers };
